import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import './component.scss';
import {find} from '@fretadao/f-js-dom';

application.register('slider', class extends Controller {

  connect() {
    this.updateSlider();
  }

  updateSlider() {
    const slider = find('.Slider-input');
    slider.setAttribute('value', slider.value);
    const stepPercentage = 100 / ((Number(slider.max) - Number(slider.min)) / Number(slider.step)) ;
    const percentageValue = (slider.valueAsNumber - Number(slider.min)) * stepPercentage;

    const firstColor = slider.dataset.firstColor + ' ' + percentageValue + '%';
    const secondColor = slider.dataset.secondColor + ' ' + percentageValue + '%';
    const fillColor = 'linear-gradient(90deg, ' + firstColor + ', ' + secondColor + ')';

    slider.style.background = fillColor;
    find('.Slider-value').textContent = slider.value + ' km';
  }
})
